import React from 'react'

const Loops = () => {
    return (
        <div className='container'>
            <h1>Loop in C</h1>
            <p>The looping can be defined as repeating the same process multiple times
                 until a specific condition satisfies. There are three types of loops used
                  in the C language. In this part of the tutorial, we are going to learn
                   all the aspects of C loops.</p>
                   <h3>Why use loops in C language?</h3>
                   <p>The looping simplifies the complex problems into the easy ones. It enables us to alter the flow of the program so that instead of writing the same code again and again, we can repeat the same code for a finite number of times. For example, if we need to print the first 10 natural numbers then, instead of using the printf statement 10 times, we can print inside a loop which runs up to 10 iterations.</p>
                <h3>Advantage of loops in C</h3>
                <p>1) It provides code reusability. <br />

2) Using loops, we do not need to write the same code again and again. <br />

3) Using loops, we can traverse over the elements of data structures (array or linked lists). <br />  </p>
<h3>Types of C Loops</h3>
<p>There are three types of loops in C language that is given below:</p>
<ol>
    <li>do while</li>
    <li>while</li> 
    <li>for</li> 
</ol>
<h3>do-while loop in C</h3>
<p>The do-while loop continues until a given condition satisfies. It is also called post tested loop. It is used when it is necessary to execute the loop at least once (mostly menu driven programs).
<br /><br />
The syntax of do-while loop in c language is given below:</p>
<div className='containers' >
<div className='keywords' > do</div>&#123; <br />
<div className='comment' >//code to be executed  </div> 
&#125;<div className='keywords' > while</div>(condition); <br /> 
</div>
<h3>while loop in C</h3>
The while loop in c is to be used in the scenario where we don't know the number of iterations in advance. The block of statements is executed in the while loop until the condition specified in the while loop is satisfied. It is also called a pre-tested loop.
<br />s
The syntax of while loop in c language is given below: <br />
<div className='containers'>
<div className='keywords' >while</div>(condition)&#123;  <br />

<div className='comment' >//code to be executed  </div> <br />
&#125; 
</div>
<h3>for loop in C</h3>
<p> The for loop is used in the case where we need to execute some part of the code until the given condition is satisfied. The for loop is also called as a per-tested loop. It is better to use for loop if the number of iteration is known in advance.
</p><br />
<p> The syntax of for loop in c language is given below:</p> <br />
<div className='containers'>
<div className='keywords' >for</div>(initialization;condition;incr/decr)&#123;
<div className='comment' >//code to be executed  </div>
&#125;  
</div> 
        </div>
    )
}

export default Loops
